var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"row justify-content-start mb-4"},[_c('div',{staticClass:"col-12 col-sm-4 mb-3"},[(!_vm.getLoading)?_c('BarChart',{attrs:{"labels":_vm.hoursGraphLabels,"datasets":_vm.alarmsGraphDatasets,"title":_vm.$t('sections.alarmsmLandingPage.alarmsGraphTitle')}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }